import SVG from 'react-inlinesvg';
import classnames from 'classnames';
import React from 'react';

import InfoSVG from '@krea/common/images/svg/warning-icon.svg';

export const Warning = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  return (
    <div
      className={classnames('tw-flex tw-leading-[0]', className)}
      style={{ fontSize: '0', color: '#ffc107' }}
    >
      <div className={classnames('tw-mr-2 tw-shrink-0 tw-w-[20px]')}>
        <SVG className="tw-w-full tw-h-auto tw-fill-current" src={InfoSVG} />
      </div>
      <div className={classnames('tw-leading-6 ')}>{children}</div>
    </div>
  );
};
